import { useEffect, useState } from 'react'
import api from '../services/api'

// Admissão / Demissão do funcionário (TMOTCA2 do ERP, frota.motca2).
// Admissão já gravada é a chave da linha e não muda; linha não pode ser excluída (igual ao ERP).

interface Linha { adm: string; dem: string; obs: string; usu: string; nova?: boolean }

export default function FuncionarioAdmissaoModal({ motcod, motnome, onClose, onSalvo }: {
  motcod: string; motnome: string; onClose: () => void; onSalvo?: () => void
}) {
  const [linhas, setLinhas] = useState<Linha[] | null>(null)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar() {
    const r = await api.get(`/funcionarios/${encodeURIComponent(motcod)}/admissoes`)
    setLinhas(r.data)
  }

  useEffect(() => {
    carregar().catch(() => setErro('Não foi possível carregar as admissões do funcionário.'))
  }, [motcod])

  const set = (i: number, campo: keyof Linha, valor: string) =>
    setLinhas(ls => ls!.map((l, j) => (j === i ? { ...l, [campo]: valor } : l)))

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put(`/funcionarios/${encodeURIComponent(motcod)}/admissoes`, { linhas })
      await carregar()
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Admissão/Demissão salva.')
      if (!r.data?.semAlteracao) onSalvo?.()
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar admissão/demissão.')
    } finally {
      setSalvando(false)
    }
  }

  const th: React.CSSProperties = { textAlign: 'left', padding: '0.45rem 0.6rem', fontSize: '0.72rem' }
  const td: React.CSSProperties = { padding: '0.3rem 0.4rem' }
  const inp: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '0.35rem 0.5rem', fontSize: '0.82rem' }

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 760, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>

        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}>
            <h2>Admissão / Demissão — {motcod} · {motnome}</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>TMOTCA2</span>
            <button className="modal-fechar" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-corpo">
          {!linhas ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <table className="table" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th style={{ ...th, width: 150 }}>Admissão</th>
                    <th style={{ ...th, width: 150 }}>Demissão</th>
                    <th style={th}>Observação</th>
                    <th style={{ ...th, width: 100 }}>Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {linhas.length === 0 && (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: '#6b7280', padding: '1.2rem' }}>Nenhuma admissão lançada.</td></tr>
                  )}
                  {linhas.map((l, i) => (
                    <tr key={l.nova ? `nova-${i}` : l.adm}>
                      <td style={td}>
                        <input type="date" value={l.adm} disabled={!l.nova} style={inp}
                          title={l.nova ? undefined : 'Admissão já gravada não pode ser alterada'}
                          onChange={e => set(i, 'adm', e.target.value)} />
                      </td>
                      <td style={td}>
                        <input type="date" value={l.dem} style={inp} onChange={e => set(i, 'dem', e.target.value)} />
                      </td>
                      <td style={td}>
                        <input value={l.obs} maxLength={50} style={inp} onChange={e => set(i, 'obs', e.target.value.toUpperCase())} />
                      </td>
                      <td style={{ ...td, fontSize: '0.8rem', color: '#6b7280' }}>{l.usu || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-secondary btn-sm" style={{ marginTop: '0.75rem' }}
                onClick={() => setLinhas(ls => [...ls!, { adm: '', dem: '', obs: '', usu: '', nova: true }])}>
                + Nova admissão
              </button>
              <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.75rem 0 0' }}>
                A última admissão define a situação do funcionário: com demissão fica Inativo, sem demissão fica Ativo.
              </p>
            </>
          )}

          {linhas && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '1rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '1rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando || !linhas}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  )
}
